import React from "react";
import Device from "../models/Device";
import { sortArrayByProperty } from "../models/utils";
import { isUiModeDeveloper } from "../uiMode";
import ObjectReference from "./ObjectReference";
import Scene from "../models/Scene";
import { SceneBehaviours } from "./SceneProperties/SceneBehaviours";
import Channel from "../models/Channel";
import Connection from "../models/Connection";
import ExpandButton from "./ExpandButton";
import { itx, noItx } from "../translationItx/itx";

export default function KnxSceneTable(props: { device: Device }) {
  const { device } = props;

  const requestChannels = device.channels.sortBy("tag");

  function OneSceneRow(props: { channel: Channel; scene: Scene; connection: Connection }) {
    const { channel, scene, connection } = props;

    const [expanded, setExpanded] = React.useState<boolean>(false);
    const sceneInfo = connection.knxSceneInfo;

    let debugData: any = null;
    try {
      if (isUiModeDeveloper() && expanded) {
        debugData = (
          <div style={{ marginTop: "10px", color: "grey", whiteSpace: "pre-wrap" }}>
            {connection.knxSceneInfo
              ? JSON.stringify(connection.knxSceneInfo, null, 2)
              : itx("KnxSceneTable.noknxsceneinfoavailable", "No KnxSceneInfo available")}{" "}
          </div>
        );
      }
    } catch (ex: any) {
      debugData = <div>{ex.message}</div>;
      console.error(ex);
    }

    return (
      <div className="estadaColumn left w100 gap">
        <div
          className="estadaRow w100 left"
          style={{
            padding: "3px",
            marginBottom: "20px",
            backgroundColor: "lightgrey",
          }}
        >
          <ExpandButton isExpanded={expanded} setIsExpanded={setExpanded} />
          &nbsp;&nbsp;&nbsp;
          <ObjectReference obj={scene} showName={true} useAllwaysMaxSpace={true} style={{ minWidth: "300px" }} />
        </div>

        {expanded && sceneInfo && <SceneBehaviours channel={channel} scene={scene} connection={connection} />}

        {expanded && !sceneInfo && (
          <div>{`No scene info available for scene ${scene.name} on channel ${channel.name}`}</div>
        )}

        {isUiModeDeveloper() && expanded && (
          <div className="estadaRow left gap" style={{ marginTop: "10px", color: "grey", whiteSpace: "pre-wrap" }}>
            <div>
              {noItx("numberId=")} {connection.knxSceneInfo?.numberId || "-- no numberId --"}{" "}
            </div>
            <div>
              {noItx("activateId=")} {connection.knxSceneInfo?.activateId || "-- no activateId --"}
            </div>
          </div>
        )}

        {debugData}
      </div>
    );
  }

  const elementsRows: any = [];
  requestChannels.forEach((channel) => {
    channel.getAllConnectedConsumers().forEach((consumer) => {
      elementsRows.push(
        <div
          className="estadaRow w100 left"
          style={{
            padding: "5px",
            paddingLeft: "10px",
            marginTop: "20px",
            color: "white",
            backgroundColor: "grey",
          }}
        >
          {/* <ExpandButton isExpanded={expanded} setIsExpanded={sided} /> */}
          {itx("KnxSceneTable.channel", "Kanal")}: &nbsp;&nbsp;
          {isUiModeDeveloper() && channel.tag}
          {channel.knxChannel?.name || ""}
          <ObjectReference obj={consumer} showName={true} useAllwaysMaxSpace={true} style={{ marginLeft: "20px" }} />
        </div>,
      );

      const scenes = sortArrayByProperty(consumer.getConnectedScenes(), "name");

      if (scenes.length === 0) {
        elementsRows.push(
          <div style={{ marginLeft: "50px", marginBottom: "10px", fontStyle: "italic" }}>
            {itx("KnxSceneTable.noscenesconnected", "No scenes connected")}
            <br />
            {isUiModeDeveloper() && (
              <div style={{ whiteSpace: "pre" }}>{JSON.stringify(channel.knxChannel?.knxSceneInfos, undefined, 2)}</div>
            )}
          </div>,
        );
      }

      scenes.forEach((scene) => {
        const connection = consumer.getConnectionWith(scene);
        if (connection) {
          elementsRows.push(
            <div style={{ marginLeft: "50px", marginBottom: "10px" }}>
              <OneSceneRow scene={scene} channel={channel} connection={connection} />
            </div>,
          );
        }
      });
    });
  });

  return <div className="estadaColumn left w100">{elementsRows}</div>;
}
